export default {
  COUNT: "COUNT",
  HOURS: "HOURS",
};
